import _ from 'lodash';
import { createReducer } from '../../../../common/reduxHelpers';
import * as types from './actionTypes';

export const initialState = {
    productsList: [],
    isLoading: false
};

const reducer = createReducer(initialState, {
    [types.FETCH_SOFTWARE_PRODUCTS_SUCCESS](state, action) {
        return _.assign({}, state, {
            productsList: [...action.response],
            isLoading: false
        });
    },

    [types.FETCH_SOFTWARE_PRODUCTS_REQUEST](state, action) {
        return _.assign({}, state, {
            productsList: [],
            isLoading: true });
    },

    [types.FETCH_SOFTWARE_PRODUCTS_FAILURE](state, action) {
        return _.assign({}, state, {
            productsList: [],
            isLoading: false
        });
    }
});

export default reducer;